import Loading from '@/common/components/Loading';
import { WrapperWithScroll } from '@/common/styles/Wrappers';
import useQueueLeadsGuessingReport from './hooks/useQueueLeadsGuessingReport';
import { getQueueGuessingRows } from './helpers/getQueueGuessingRows';
import Table from '@/common/components/Table';

const COLUMNS = [
	'No',
	'Creation Date',
	'Queue',
	'T2 Fresh',
	'Min Left',
	'Target Dequeue Count',
	'Current Friday',
	'Next Friday',
];

const QueueLeadsGuessingReport = () => {
	const hook = useQueueLeadsGuessingReport();

	return (
		<>
			{hook.isLoading && <Loading nBest={hook.calculation} />}
			<WrapperWithScroll>
				{hook?.data && (
					<Table
						className='styled-table'
						raws={getQueueGuessingRows(hook.data)}
						headers={COLUMNS}
					/>
				)}
			</WrapperWithScroll>
		</>
	);
};

export default QueueLeadsGuessingReport;
